import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import {useFetch} from '../../hooks/useFetch'

import Loading from '../../components/Loading';

import { Bloco, RankingHeader} from './index';
import { sanitizarNumero } from '../../utils/sanitizarNumero';

import {
    //RankingMunicipio2
    DivCenterVertical,
    ListConteiner,

    //ComoEFeitoOsCalculos
    // Observacao,

    // // BlocoMunicipios
    // RankingBloco,
    // Icone,
    // Nome,
    // Dados,
    // Pontos,

} from './styled'

let modos_values_predef = [
    "Aluno",
    "Educador"
]
function RankingEduca() {
    const {data: RankingEducaData } = useFetch(`ranking/educa`)
    const [modoAtv, setModoAtv] = useState(modos_values_predef[0]) // Modo ativado
    const [searchParams, setSearchParams] = useSearchParams();

    if (!RankingEducaData) return (<Loading texto='Carregando informações...' />)

    const modos_values = RankingEducaData.map(x => x.nome)

    const RankingData = RankingEducaData.find(x => x.nome === modoAtv).users

    console.log({ modoAtv, RankingData, n_user: RankingData.length })

    function trocar_modo(_){
        setSearchParams({ page: 1 })// zerar pagina
        setModoAtv(_)// trocar modo
    }
    return (<div>
        <RankingHeader
            titulo={"Educação"}
            modoAtv={modoAtv}
            setModoAtv={trocar_modo}
            modosV={modos_values}
        />
        <RankingEducaBody
            searchParams = {searchParams}
            setSearchParams = {setSearchParams}
            RankingData={RankingData}
        />
    </div>
    )
}

// function RankingEduca({RankingData}){
function RankingEducaBody({ searchParams, setSearchParams, RankingData}){

    // calculando variaveis necessarias
    const max_list = RankingData.length
    const pag_max = Math.floor(max_list / 10) + (max_list % 10 && 1)
    const page = sanitizarNumero(searchParams.get("page"), 1, pag_max)
    // configurando lista de paginas paginas
    function setPage(n) {
        return (event) => {
            event.preventDefault();
            setSearchParams({ page: n })
        }
    }
    function ElementoNavLista({p}){
        if (typeof p === "number"){
            return <li><button onClick={setPage(p)}>{p}</button></li>
        }
        return <li>{p}</li>
    }

    const lista_numero_paginas = [1]
    if (page > 1) {
        lista_numero_paginas.push("...")
    }

    const base = page >= 4 ? -2 : 1;
    for (let i = base; i <= base + 3; i++){
        if (i !== 0 && page + i < pag_max) {
            lista_numero_paginas.push(page+i)
        }
    }

    if (page < pag_max - 3){
        lista_numero_paginas.push("...")
    }
    lista_numero_paginas.push(pag_max)

    const lista_paginas = lista_numero_paginas.map(
        (p, i) => <ElementoNavLista p={p} key={i} />
    )

    function geraBlocoRanking(blocoData, pos) {
        return (
            <Bloco
                key={`bloco_id_${pos+1}`}
                pos={pos + 1}
                username={blocoData.username}
                pontos={blocoData.pontos}
                municipio={blocoData.municipio}
                nome={blocoData.nome}
            />
        )
    }
    const salto_offset = (page === 1 ? 3 : 0);
    return (
        <DivCenterVertical className='ranking-body'>
          <ListConteiner>
            {RankingData
                .slice(0, 3)
                .map((blocoData, pos) => geraBlocoRanking(blocoData, pos))
            }
            {page>1 && <hr size="20"/>}
            {RankingData
                .slice((page - 1) * 10 + salto_offset, (page)*10)
                .map((blocoData, pos) => geraBlocoRanking(blocoData,
                    (page - 1) * 10 + pos + salto_offset)
                )
            }
            </ListConteiner>


            <nav className='ranking-nav-page'>
                <h2>{`Página ${page} de ${pag_max}`}</h2>
                <ul className="nav-page-bar">
                    <li>{ page > 1 &&
                       <button onClick={setPage(page - 1)}>Voltar</button>
                    } </li>
                    {lista_paginas}
                    <li>{page  < pag_max &&
                        <button onClick={setPage(page + 1)}>Avançar</button>
                    }</li>
                </ul>
            </nav>
        </DivCenterVertical>
    )

}

export default RankingEduca;
